module.exports = "<travel-requests-page></travel-requests-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/travelRequests.html
// module id = 1921
// module chunks = 0